import { jsx as _jsx } from "react/jsx-runtime";
import { T } from '@sm/intl';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Menu } from '@wds/menu';
import { trackAmplitudeEvent } from '../../../lib';
import { useGeneral } from '../../../Context';
export const COPY = {
  addThemesButton: {
    id: 'OpenEndedCoding.ThemeMenu.addThemesButton',
    defaultMessage: 'Add {themes, plural, =1 {theme} =0 {theme} other {themes}}',
    description: '[Type: Header][Vis: med] - button text theme selection'
  },
  addAndTagButton: {
    id: 'OpenEndedCoding.ThemeMenu.addAndTagButton',
    defaultMessage: 'Add theme and tag',
    description: '[Type: Header][Vis: med] - button text theme creation'
  }
};
const AddButton = ({
  allThemes,
  themesSelected,
  search,
  disabled,
  handleSaveThemes,
  handleThemeCreationForResponse
}) => {
  const showAddThemesButton = themesSelected.length > 0 || search === '' || !!allThemes.find(({
    theme
  }) => theme === search);
  const {
    surveyId,
    questionId,
    isSolutions
  } = useGeneral();
  if (showAddThemesButton) {
    return _jsx(Menu.Item, {
      disabled: themesSelected.length === 0 || disabled,
      onClick: () => {
        handleSaveThemes();
        // tracking
        trackAmplitudeEvent({
          amplitudeEvent: 'open-ended coding applied theme',
          data: {
            surveyId,
            questionId,
            pageName: isSolutions ? 'ctm' : 'analyze',
            themeType: 'existing theme'
          }
        });
      },
      children: _jsx(Box, {
        px: 3,
        children: _jsx(Button, {
          disabled: themesSelected.length === 0 || disabled,
          color: "link",
          stretched: true,
          children: _jsx(T, {
            desc: COPY.addThemesButton,
            values: {
              themes: themesSelected.length
            }
          })
        })
      })
    });
  }
  return _jsx(Menu.Item, {
    onClick: () => {
      handleThemeCreationForResponse();
      // tracking
      trackAmplitudeEvent({
        amplitudeEvent: 'open-ended coding applied theme',
        data: {
          surveyId,
          questionId,
          pageName: isSolutions ? 'ctm' : 'analyze',
          themeType: 'new theme'
        }
      });
    },
    children: _jsx(Box, {
      px: 3,
      children: _jsx(Button, {
        stretched: true,
        color: "secondary",
        variant: "ghost",
        children: _jsx(T, {
          desc: COPY.addAndTagButton
        })
      })
    })
  });
};
export default AddButton;